/** Where a read that answers in the background has got to. */
export type ReadOutcome<T> =
  { kind: "reading" } | { kind: "failed" } | { kind: "read"; value: T };

/** Both values once both are read; failed as soon as either fails. */
export const bothRead = <First, Second, Combined>({
  first,
  second,
  combine,
}: {
  first: ReadOutcome<First>;
  second: ReadOutcome<Second>;
  combine: (values: { first: First; second: Second }) => Combined;
}): ReadOutcome<Combined> => {
  if (first.kind === "failed" || second.kind === "failed") {
    return { kind: "failed" };
  }

  if (first.kind === "reading" || second.kind === "reading") {
    return { kind: "reading" };
  }

  return {
    kind: "read",
    value: combine({ first: first.value, second: second.value }),
  };
};
